// extracted by mini-css-extract-plugin
module.exports = {"root":"heading_root__8jil3","subTitle":"heading_subTitle__j7wDu"};